// extracted by mini-css-extract-plugin
export var boldtext = "embedsuzuri-module--boldtext--dccf8";
export var itemlogo = "embedsuzuri-module--itemlogo--2cd61";
export var suzuricontentswrapper = "embedsuzuri-module--suzuricontentswrapper--0c5aa";
export var suzuriwrapper = "embedsuzuri-module--suzuriwrapper--a7c9f";
export var text = "embedsuzuri-module--text--f6e34";